import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import Drawer from '@mui/material/Drawer'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconClose from '@assets/images/icons/v2/close.svg'

const useStyles = makeStyles(theme => ({
  paper: {
    width: ({ width }) => width ?? 'auto',
    minWidth: ({ width, minWidth }) => minWidth ?? (width ? 'unset' : 500),
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: () => '100%',
    },
  },
  header: {
    height: 85,
    padding: '0px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.borderColor}`,
    flexShrink: 0,
    backgroundColor: theme.backgroundColor,
    [theme.breakpoints.down('md')]: {
      padding: '0px 20px',
    },
  },
  headline: {
    fontSize: 20,
    lineHeight: '26px',
    letterSpacing: '0.2px',
    flexGrow: 1,
  },
  close: {
    cursor: 'pointer',
  },
}))

const SimpleDrawer = (props) => {
  const classes = useStyles(props)
  const {
    open,
    onClose,
    children,
    enableBackdropClick = true,
    headline = undefined,
    noHeader,
    className,
    headerClassName,
    anchor = 'right',
    drawerProps,
    rootClassName,
    paperClassName,
    dataQsId,
  } = props

  return (
    <Drawer
      classes={{
        root: rootClassName,
        paper: clsx(classes.paper, paperClassName),
      }}
      {...drawerProps}
      anchor={anchor}
      transitionDuration={400}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' || enableBackdropClick) {
          onClose && onClose()
        }
      }}
      ModalProps={{
        disableEscapeKeyDown: true,
        container: document.fullscreenElement ?? document.body,
      }}
      data-qs-id={dataQsId}
    >
      <div className={clsx('flex-auto', className)}>
        {!noHeader && <div className={clsx(classes.header, headerClassName)}>
          {headline && (<span className={classes.headline}>{headline}</span>)}
          <SVGIcon onClick={onClose} className={classes.close} svg={IconClose} width="12px" height="12px" />
        </div>}
        {children}
      </div>
    </Drawer>
  )
}

SimpleDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  enableBackdropClick: PropTypes.bool,
  headline: PropTypes.string,
  noHeader: PropTypes.bool,
  drawerProps: PropTypes.object,
  width: PropTypes.string,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  rootClassName: PropTypes.string,
  paperClassName: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

export default SimpleDrawer
